import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { authApi } from "../lib/api";
import { useAuth } from "../context/AuthContext";

/** Dedupe concurrent verify calls (React Strict Mode remount). */
const verifyInflight = new Map();

function verifyEmailOnce(token) {
  if (!verifyInflight.has(token)) {
    const p = authApi.verifyEmail(token).finally(() => {
      // Keep resolved promise briefly so a remount can reuse the result
      setTimeout(() => verifyInflight.delete(token), 10_000);
    });
    verifyInflight.set(token, p);
  }
  return verifyInflight.get(token);
}

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const { applyUser, refresh } = useAuth();
  const [status, setStatus] = useState("loading");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setMessage("Hiányzó megerősítő token.");
      return;
    }

    let cancelled = false;

    (async () => {
      try {
        const data = await verifyEmailOnce(token);
        if (cancelled) return;
        if (data.user) applyUser(data.user);
        else await refresh();
        setStatus("ok");
        setMessage(data.message || "E-mail megerősítve.");
      } catch (err) {
        if (cancelled) return;
        setStatus("error");
        setMessage(err.message || "A megerősítés sikertelen.");
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [token, applyUser, refresh]);

  return (
    <div className="max-w-md mx-auto px-4 pt-24 pb-16 text-center">
      <h1 className="text-3xl font-bold mb-4">E-mail megerősítés</h1>
      {status === "loading" && <p className="text-gray-600">Ellenőrzés…</p>}
      {status === "ok" && (
        <div className="rounded-lg border border-emerald-200 bg-emerald-50 text-emerald-900 px-4 py-3">
          {message}
          <div className="mt-4">
            <Link to="/fiok" className="text-blue-700 underline">
              Tovább a fiókomhoz
            </Link>
          </div>
        </div>
      )}
      {status === "error" && (
        <div className="rounded-lg border border-red-200 bg-red-50 text-red-800 px-4 py-3">
          {message}
          <div className="mt-4 space-y-2">
            <p className="text-sm text-red-900/80">
              Ha a link lejárt vagy már felhasználták, a fiókodban kérhetsz új
              megerősítő e-mailt.
            </p>
            <Link to="/fiok" className="text-blue-700 underline">
              Fiók
            </Link>
          </div>
        </div>
      )}
    </div>
  );
}
